<template>
    <div id="comment">
        <Emoji @change="onChange" :value="value" :clearContent="clearContent" @clear="clearContent = false" :focus="focus" :placeholder="placeholder" />
        <van-button id="button-send" type="primary" size="small" @click="onComment">发送</van-button>
    </div>
</template>

<script>
  import Emoji from '@/components/Emoji';
  import {Button} from 'vant';


  export default {
    name: 'Comment',
    components: {
      Emoji,
      [Button.name]: Button,

    },
    props: {
      // 文档类型
      type: {
        type: String,
        required: true
      },
      // 文档文章id
      objectId: {
        type: String,
        required: true
      },
      // 父级评论id
      parentId: {
        type: [String, Number],
        default: 0
      },
      value: {
        type: String,
        default: ''
      },
      focus: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        preContent: this.value,
        commentData: '',
        loading: false,
        commented: false,
        clearContent: false
      };
    },
    watch: {
      commentData() {
        this.commented = false;
      }
    },
    methods: {
      onComment() {
        if (!this.commentData || this.loading || this.commented)
          return;
        this.loading = true;
        let data = {
          type: this.type,
          objectId: this.objectId,
          parentId: this.parentId,
          content: this.commentData
        };
        this.$http.post('/api/comment/create', data).then(({id}) => {
          this.loading = false;
          this.commented = true;
          this.commentData = '';
          this.clearContent = true;
          this.$emit('success', {...data, id});
        }).catch(() => {
          this.loading = false;
          this.$emit('error', data);
        });
      },
      onChange(event) {
        // event.data contains the value of the textarea
        this.commentData = event;
      }
    }
  };
</script>

<style scoped lang="less">
    #comment {
        position: relative;
        #button-send {
            position: absolute;
            top: 9px;
            right: 8px;
        }
    }

</style>